module.exports = [{
      plugin: require('../../../node_modules/@sentry/gatsby/gatsby-browser.js'),
      options: {"plugins":[],"dsn":"https://ae36eedd65864f60919d20d4d4f2e732@sentry.io/5196369","sampleRate":1,"environment":"gatsby-production","enabled":true},
    },{
      plugin: require('../../../node_modules/@ninetailed/experience.js-gatsby/gatsby-browser.js'),
      options: {"plugins":[],"clientId":"732b57ad-e18f-4e3e-8c50-d9ac8532125a","environment":"main","ninetailedPlugins":[{"resolve":"@ninetailed/experience.js-plugin-insights","options":{}},{"resolve":"@toasttab/shared/src/utils/Ninetailed/ninetailedHeap","options":{}}],"useSDKEvaluation":false},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
